import { useCallback } from "react";
import { useMutation } from "@apollo/client";

import { useConfirmDialog } from "@/hooks/use-confirm-dialog";
import { CREATE_CUSTOMER } from "@/graphql/mutations";

import { Customer, CustomerForm } from "@/interfaces/customer";

export function useCreateCustomer() {
	const [create, { loading }] = useMutation<{
		createCustomer: Customer;
	}>(CREATE_CUSTOMER);
	const { confirm } = useConfirmDialog();

	const createCustomer = useCallback(
		async (customer: CustomerForm) => {
			try {
				const {
					fullName,
					documentType,
					documentNumber,
					address,
					phoneNumber,
					email,
				} = customer;

				const { data } = await create({
					variables: {
						customer: {
							id: window.crypto.randomUUID(),
							fullName: fullName.trim(),
							documentType: documentType,
							documentNumber: documentNumber,
							address: address === "" ? undefined : address,
							phoneNumber: phoneNumber === "" ? undefined : phoneNumber,
							email: email === "" ? undefined : email,
						},
					},
					fetchPolicy: "no-cache",
				});

				if (!data?.createCustomer)
					throw new Error("No se pudo crear el cliente.");

				return data.createCustomer;
			} catch (error: unknown) {
				await confirm({
					type: "error",
					content: (error as Error).message,
					showCancelButton: false,
					title: "No pudimos crear el cliente. Por favor, intenta nuevamente.",
					confirmLabel: "Aceptar",
				});
			}
		},
		[create, confirm],
	);

	return { createCustomer, loading };
}
